import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";
import { useProject } from "../project";

export function useReorderDeliverablesMutation(workstreamId: string) {
    const { project } = useProject();
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (deliverableIds: string[]) => {
            await apiClient.reorderDeliverables({
                params: { projectId: project.id, workstreamId },
                body: { deliverableIds },
            });
            await queryClient.refetchQueries({ queryKey: ["project", project.id] });
        },
    });
}
